import { useEffect, useState } from "react";
import { recruitmentApi } from "../../../../services/recruitmentService";
import ShopSelect from "../../../../components/ShopSelect";
import { Dialog, plainError } from "../../../../components/ui";

const inputClass = "w-full rounded-xl border border-neutral-300 bg-white px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-neutral-400 dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-100";

export default function DirectHireModal({ onClose, onCreated }) {
  const [roles, setRoles] = useState([]);
  const [roleId, setRoleId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    recruitmentApi.roles().then((response) => {
      if (active) setRoles(response.roles || []);
    }).catch((loadError) => { if (active) setError(loadError?.message || "Could not load business roles."); });
    return () => { active = false; };
  }, []);

  async function submit(event) {
    event.preventDefault();
    if (!roleId || busy) return;
    setBusy(true);
    setError("");
    try {
      const response = await recruitmentApi.createDirectHire({ roleId, firstName: firstName.trim(), lastName: lastName.trim(), email: email.trim() });
      onCreated(response.result);
    } catch (submitError) {
      setError(plainError(submitError, "The direct hire was not started. Try again."));
    } finally { setBusy(false); }
  }

  // A data-entry form (C2): it says what starting does, names the action, and keeps a refusal in the dialog.
  return (
    <Dialog
      open
      onOpenChange={(isOpen) => { if (!isOpen && !busy) onClose(); }}
      title="Start direct hire"
      description="Creates a candidate record and emails them the onboarding form. Employment starts only when they are activated."
    >
      <form onSubmit={submit} className="space-y-4 pb-2">
        <div><label className="mb-1 block text-xs font-semibold">Position *</label><ShopSelect value={roleId} onValueChange={setRoleId} options={[{ value: "", label: "Choose position" }, ...roles.map((role) => ({ value: String(role.id), label: `${role.display_name || role.name}${role.department_name ? ` — ${role.department_name}` : ""}` }))]} ariaLabel="Position" triggerClassName="min-h-10 w-full rounded-xl px-3 py-2 text-sm" />{!roles.length && <p className="mt-1 text-xs text-neutral-500">No active, assignable business roles are available.</p>}</div>
        <div className="grid gap-4 sm:grid-cols-2"><div><label htmlFor="direct-first" className="mb-1 block text-xs font-semibold">First name *</label><input id="direct-first" className={inputClass} required maxLength={120} value={firstName} onChange={(event) => setFirstName(event.target.value)} /></div><div><label htmlFor="direct-last" className="mb-1 block text-xs font-semibold">Last name *</label><input id="direct-last" className={inputClass} required maxLength={120} value={lastName} onChange={(event) => setLastName(event.target.value)} /></div></div>
        <div><label htmlFor="direct-email" className="mb-1 block text-xs font-semibold">Email *</label><input id="direct-email" className={inputClass} type="email" required maxLength={254} value={email} onChange={(event) => setEmail(event.target.value)} /></div>
        <div className="flex justify-end gap-2 pt-2"><button type="button" onClick={onClose} disabled={busy} className="rounded-xl border border-neutral-300 px-4 py-2 text-sm dark:border-neutral-700">Cancel</button><button type="submit" disabled={busy || !roleId} className="business-primary-action rounded-xl bg-neutral-900 px-4 py-2 text-sm font-semibold text-white disabled:opacity-50 dark:bg-neutral-100 dark:text-neutral-900">{busy ? "Starting…" : "Start onboarding"}</button></div>
        {error && <p role="alert" className="rounded-control border border-danger bg-danger-subtle p-3 text-body-sm text-danger">{error}</p>}
      </form>
    </Dialog>
  );
}
